angular.module('charts')
  .directive("studentsList", function () {
      return {
          restrict: "E",
          scope: {
              students: '=',
              labelMod: '=',
              astName: '=',
              astType: '='
          },
          templateUrl: '/resources/charts/partials/students-list.html',
          controller: [
              '$scope',
              '$element',
              'assignMode',
              'authentication',
              'customer',
              'dblAcademicMappingStringCustomizerService',
              'translateFilter', function (
                  $scope,
                  $element,
                  $assignMode,
                  dblAuthentication,
                  customer,
                  stringCustomizer,
                  translateFilter) {

              $scope.notStarted = [];
              $scope.needAttention = [];
              $scope.inProgress = [];
              $scope.completed = [];
              $scope.isAssignMode = $assignMode.isAssignMode;

              $scope.$watch('students', function (newVal, oldVal) {
                  if (newVal) {
                      $scope.notStarted = [];
                      $scope.needAttention = [];
                      $scope.inProgress = [];
                      $scope.completed = [];

                      $scope.notStarted = _.filter(newVal, function (item) {
                          return item.proficiency_status === 'NOT_STARTED';
                      });

                      $scope.needAttention = _.filter(newVal, function (item) {
                          return item.proficiency_status === 'NEEDS_ATTENTION';
                      });

                      $scope.inProgress = _.filter(newVal, function (item) {
                          return item.proficiency_status === 'IN_PROGRESS';
                      });

                      if ($scope.progressValue === "fraction") {
                          $scope.inProgress = _.sortByOrder($scope.inProgress, 'standards_completed', false);
                      }

                      $scope.completed = _.filter(newVal, function (item) {
                          return item.proficiency_status === 'PROFICIENT';
                      });
                  }
              });

              $scope.$watch('studentListForm.$dirty', function (dirty) {
                  $scope.$emit('studentListFormDirty', dirty);
              });

              $scope.$on('assignLessonSuccess', function() {
                  $scope.studentListForm.$setPristine();
              });

              $scope.$watch('labelMod', function() {
                  $scope.progressValue = 'fraction';
                  if ($scope.labelMod === 'STANDARD') {
                      $scope.progressValue = "percent";
                  }
              });

              $scope.getProficientLabel = function() {
                  //PROFICIENT{{labelMod != '' ? ' IN ' : ''}}{{labelMod | domainText : astName}}
                  if ($scope.labelMod === '') {
                      return translateFilter('academicMappingStringCustomizer.proficient');
                  } else {
                      return stringCustomizer.render(_astType(), 'PROFICIENT IN', {focus: $scope.labelMod});
                  }
              };

              $scope.getProficientDescription = function() {
                  //{{astType}}{{labelMod != 'STANDARD' ? 'in all available standards in ' : ''}}{{labelMod != '' ? '' : 'grade'}}{{labelMod | domainText : astName}}{{labelMod == 'STANDARD' ? ' met' : ''}}
                  var focus = $scope.labelMod === '' ? 'GRADE' : $scope.labelMod;
                  if (focus === 'STANDARD') {
                      return stringCustomizer.render(_astType(), 'STANDARD MET', {focus: focus});
                  } else {
                      focus = translateFilter('grade');
                      return stringCustomizer.render(_astType(), 'IN ALL AVAILABLE STANDARDS', {focus: focus});
                  }
              };

              function _astType() {
                  return $scope.astType ? $scope.astType : 'STANDARD';
              }
          }]
      };
  });
